import clsx from "clsx";
import Button from "../Button";
import styles from "./ReviewStep.module.scss";
import StepIndicator from "./StepIndicator";

interface Props {
  stepsComplete: number;
  isLocked?: boolean;
  openModal: () => void;
}

export default function ReviewStep({
  stepsComplete,
  isLocked = false,
  openModal,
}: Props) {
  const reviewDocuments = () => {
    openModal();
  };

  return (
    <div className="d-flex">
      <StepIndicator stepNumber={3} isLocked={isLocked} />
      <div className={styles.container}>
        <div
          className={clsx(
            styles.box,
            "d-flex justify-content-between align-items-center",
            isLocked && styles.locked,
          )}
        >
          <div data-testid="review-step-title" className={styles.title}>
            Review documents
          </div>
          <div
            data-testid="review-step-description"
            className={styles.description}
          >
            {stepsComplete} of 2 required steps completed
          </div>
          <form>
            <Button
              data-testid="review-step-button"
              size="sm"
              className={styles.uploadButton}
              type="button"
              disabled={isLocked}
              onClick={reviewDocuments}
            >
              Review
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
}
